/**
 * Customize to adjust styles on kit widget
 */

import { TableCell } from '@/components/blocks/Table/TableCell';
import { TableRow } from '@/components/blocks/Table/TableRow';
import { kitTableRowSX } from '@/components/content/Kit/styles/Table/Row';
import { KitTableData } from '@/data/types/Product';
import { Row, flexRender } from '@tanstack/react-table';
import { FC } from 'react';

export const KitTableRow: FC<{ row: Row<KitTableData> }> = ({ row }) => (
	<TableRow expanded={row.getIsExpanded()} expandedContent={!row.getCanExpand()}>
		{row.getVisibleCells().map((cell, i) =>
			row.getCanExpand() || i === 0 ? (
				<TableCell key={i} {...(row.getCanExpand() ? {} : { colSpan: 3 })} sx={kitTableRowSX}>
					{flexRender(cell.column.columnDef.cell, cell.getContext())}
				</TableCell>
			) : null
		)}
	</TableRow>
);
